import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

const SKIP = /^\/(admin|espace-developpeur|espace-client)(\/|$)/;

// One lightweight beacon per page view (aggregated server-side; no cookie, no personal data).
export const StatsBeacon = () => {
  const { pathname } = useLocation();
  const { lang } = useI18n();
  useEffect(() => {
    if (SKIP.test(pathname) || navigator.webdriver) return;
    api.post("/stats/beacon", { path: pathname, lang }).catch(() => {});
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};
